// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3H0b4","requiredAsterisk":"Info_requiredAsterisk__2RZuP"};